import { Divider, Form } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import React, {useEffect} from 'react'

export function RegistrationFormSl({
    isSl,
    form,
    record
}){ 

    useEffect(() => {
        form.setFieldsValue({
            slNotes:record?.registrations[0]?.slNotes,
        }) 
    }, // eslint-disable-next-line
    [])

    if(!isSl) {
        return null;
    }
    return (
        <>
            <Divider />
            <Form.Item
                label="SL/Admin notes"
                name="slNotes"
            >
                    <TextArea  
                        name="slNotes" 
                        rows={8}
                    />
            </Form.Item>
        </>
    )
}